// extracted by mini-css-extract-plugin
export default {"statistics":"Static_statistics__qXohZ","stat_block":"Static_stat_block__vlkxc"};